"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _DBVVP6CDcjs = require('../__chunks/DBVVP6CD.cjs');
require('../__chunks/TVPBHOOY.cjs');


var _B2PY6EORcjs = require('../__chunks/B2PY6EOR.cjs');


var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');
require('../__chunks/QWIBF3KB.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/NSONUP5C.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-radio.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "input";
var useFormRadio = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormRadio2({ store, name: nameProp, value, ...props }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormRadio must be wrapped in a Form component."
    );
    const name = String(nameProp);
    const onChangeProp = props.onChange;
    const onChange = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.setValue(name, value);
    });
    const checkedProp = props.checked;
    const checked = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      () => checkedProp != null ? checkedProp : (store == null ? void 0 : store.getValue(name)) === value
    );
    props = {
      ...props,
      checked,
      onChange
    };
    props = _DBVVP6CDcjs.useRadio.call(void 0, { value, ...props });
    props = _B2PY6EORcjs.useFormControl.call(void 0, {
      store,
      name,
      "aria-labelledby": void 0,
      ...props
    });
    return props;
  }
);
var FormRadio = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function FormRadio2(props) {
    const htmlProps = useFormRadio(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.FormRadio = FormRadio; exports.useFormRadio = useFormRadio;
